// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CharitableTrustDesignerData_BeneficiaryFragment = { __typename?: 'Beneficiary', id: string, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: { __typename?: 'AccessParameter', id: string, percentage?: Percent | null } | null } | null> | null }, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, entity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null };

export type CharitableTrustDesignerData_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string };

export type CharitableTrustDesignerData_ProposalFragment = { __typename?: 'Proposal', id: string, displayName: string, cltProposal?: { __typename?: 'CLTProposal', id: string, taxStatus: Types.TrustTaxStatus, donors: Array<(
      { __typename?: 'ClientProfile' }
      & CharitableTrustDesignerData_ClientProfileFragment
    )>, charitableIncomeBeneficiaries?: Array<(
      { __typename?: 'Beneficiary', id: string }
      & CharitableTrustDesignerData_BeneficiaryFragment
    )> | null, remainderBeneficiaries?: Array<(
      { __typename?: 'Beneficiary', id: string }
      & CharitableTrustDesignerData_BeneficiaryFragment
    )> | null } | null, crtProposal?: { __typename?: 'CRTProposal', id: string, donors: Array<(
      { __typename?: 'ClientProfile', id: string }
      & CharitableTrustDesignerData_ClientProfileFragment
    )>, charitableRemainderBeneficiaries?: Array<(
      { __typename?: 'Beneficiary', id: string }
      & CharitableTrustDesignerData_BeneficiaryFragment
    )> | null, incomeBeneficiaries?: Array<(
      { __typename?: 'Beneficiary', id: string }
      & CharitableTrustDesignerData_BeneficiaryFragment
    )> | null } | null };

export type CharitableTrustDesignerDataQueryVariables = Types.Exact<{
  proposalId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  hasProposalID: Types.Scalars['Boolean']['input'];
}>;


export type CharitableTrustDesignerDataQuery = { __typename?: 'Query', proposals?: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: (
        { __typename?: 'Proposal', id: string }
        & CharitableTrustDesignerData_ProposalFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    CharitableTrustDesignerData: 'CharitableTrustDesignerData' as const
  },
  Fragment: {
    CharitableTrustDesignerData_Beneficiary: 'CharitableTrustDesignerData_Beneficiary' as const,
    CharitableTrustDesignerData_ClientProfile: 'CharitableTrustDesignerData_ClientProfile' as const,
    CharitableTrustDesignerData_Proposal: 'CharitableTrustDesignerData_Proposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const CharitableTrustDesignerData_ClientProfileFragmentDoc = gql`
    fragment CharitableTrustDesignerData_ClientProfile on ClientProfile {
  id
  displayName
}
    `;
export const CharitableTrustDesignerData_BeneficiaryFragmentDoc = gql`
    fragment CharitableTrustDesignerData_Beneficiary on Beneficiary {
  id
  accessParameters {
    edges {
      node {
        id
        percentage
      }
    }
  }
  individual {
    id
    displayName
  }
  organization {
    id
    name
  }
  entity {
    id
    subtype {
      id
      displayName
    }
  }
  testamentaryEntity {
    id
    displayName
  }
}
    `;
export const CharitableTrustDesignerData_ProposalFragmentDoc = gql`
    fragment CharitableTrustDesignerData_Proposal on Proposal {
  id
  displayName
  cltProposal {
    id
    donors {
      ...CharitableTrustDesignerData_ClientProfile
    }
    charitableIncomeBeneficiaries {
      id
      ...CharitableTrustDesignerData_Beneficiary
    }
    remainderBeneficiaries {
      id
      ...CharitableTrustDesignerData_Beneficiary
    }
    taxStatus
  }
  crtProposal {
    id
    donors {
      id
      ...CharitableTrustDesignerData_ClientProfile
    }
    charitableRemainderBeneficiaries {
      id
      ...CharitableTrustDesignerData_Beneficiary
    }
    incomeBeneficiaries {
      id
      ...CharitableTrustDesignerData_Beneficiary
    }
  }
}
    ${CharitableTrustDesignerData_ClientProfileFragmentDoc}
${CharitableTrustDesignerData_BeneficiaryFragmentDoc}`;
export const CharitableTrustDesignerDataDocument = gql`
    query CharitableTrustDesignerData($proposalId: ID, $hasProposalID: Boolean!) {
  proposals(where: {id: $proposalId}) @include(if: $hasProposalID) {
    edges {
      node {
        id
        ...CharitableTrustDesignerData_Proposal
      }
    }
  }
}
    ${CharitableTrustDesignerData_ProposalFragmentDoc}`;

/**
 * __useCharitableTrustDesignerDataQuery__
 *
 * To run a query within a React component, call `useCharitableTrustDesignerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCharitableTrustDesignerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCharitableTrustDesignerDataQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      hasProposalID: // value for 'hasProposalID'
 *   },
 * });
 */
export function useCharitableTrustDesignerDataQuery(baseOptions: Apollo.QueryHookOptions<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>(CharitableTrustDesignerDataDocument, withFetchPolicyContext(options));
      }
export function useCharitableTrustDesignerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>(CharitableTrustDesignerDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCharitableTrustDesignerDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>(CharitableTrustDesignerDataDocument, withFetchPolicyContext(options));
        }
export type CharitableTrustDesignerDataQueryHookResult = ReturnType<typeof useCharitableTrustDesignerDataQuery>;
export type CharitableTrustDesignerDataLazyQueryHookResult = ReturnType<typeof useCharitableTrustDesignerDataLazyQuery>;
export type CharitableTrustDesignerDataSuspenseQueryHookResult = ReturnType<typeof useCharitableTrustDesignerDataSuspenseQuery>;
export type CharitableTrustDesignerDataQueryResult = Apollo.QueryResult<CharitableTrustDesignerDataQuery, CharitableTrustDesignerDataQueryVariables>;